var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgOverdueInvoices(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_9781",
    "data-name": "Group 9781",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 48.559,
    height: 48.688,
    viewBox: "0 0 48.559 48.688",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3955",
    "data-name": "Rectangle 3955",
    width: 48.558,
    height: 48.688,
    fill: "#2a4c7d"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_9745",
    "data-name": "Group 9745",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_12136",
    "data-name": "Path 12136",
    d: "M24.215,0c-32.277,1.284-32.295,47.4,0,48.688A24.344,24.344,0,1,0,24.215,0m1.759,24.344a1.829,1.829,0,0,1-.51,1.249l-7.142,7.142a1.767,1.767,0,0,1-2.5-2.5l6.631-6.614V9.586a1.759,1.759,0,1,1,3.518,0Z",
    transform: "translate(0)",
    fill: "#2a4c7d"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOverdueInvoices);
export default __webpack_public_path__ + "static/media/OverdueInvoices.b7c0b31107483d89497f4db0365df38b.svg";
export { ForwardRef as ReactComponent };